<template>
  <div class="add-prdtsearch">
    <header class="inner-header">
      <div class="top-head">
        <span class="icon-Btn go-back" @click="goBack()">
          <ArrowLeftBackIcon />
        </span>
        <h1>Back</h1>
      </div>
      <div class="serach-head">
        <input
          type="text"
          v-model="searchInput"
          @keyup="searchQuery($event)"
          class="input-bg"
          placeholder="Search Product..."
        />
        <span class="search-icon" v-if="searchInput != ''">
          <SearchIcon />
        </span>
        <span @click="searchInput = ''" class="clear-icon">
          <CloseIcon />
        </span>
      </div>
    </header>
    <div class="mid-cnt">
      <div class="no-product" v-if="!productDetails.length">
        <div class="no-item-found">
          <div class="img-block">
            <img src="../assets/images/ic_product_box_add.svg" />
          </div>
          <div class="details-block">
            <p>प्रोडक्ट को सर्च करें और अपने शॉप में जोड़ें।</p>
            <!-- <button type="button" class="ad-product" @click="addProduct()">+ प्रोडक्ट जोड़े</button> -->
          </div>
        </div>
      </div>
      <ul class="card-listing">
        <li v-for="(product_Item, index) in productDetails">
          <span class="prdt-icon">
            <img
              v-if="product_Item.itemDTOList[0].itemMediaDTOList.length"
              :src="product_Item.itemDTOList[0].itemMediaDTOList[0].thumbnail"
              alt=""
            />
            <img src="../assets/images/watermark1.jpg" alt="product" v-else />
          </span>
          <div class="prdt-info">
            <p>{{ product_Item.productName }}</p>
            <div class="price-block">
              <span class="update-price"
                >Rs. {{ product_Item.itemDTOList[0].mrp }}
              </span>
            </div>
          </div>
          <span class="prdt-btn" @click="addScannedProduct(product_Item, index)"
            >add to shop</span
          >
        </li>
      </ul>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import "../assets/css/addproduct-search.scss";
import ArrowLeftBackIcon from "../components/Icons/ArrowLeftBackIcon";
import SearchIcon from "../components/Icons/SearchIcon";
import CloseIcon from "../components/Icons/CloseIcon";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import CustomToaster from "../components/Common/CustomToaster";
import { mapGetters } from "vuex";
export default {
  name: "ProductSearch",
  data() {
    return {
      searchInput: "",
      productDetails: [],
      isValidDetail: false,
      toasterData: {},
      loading: false,
    };
  },
  components: {
    ArrowLeftBackIcon,
    SearchIcon,
    CloseIcon,
    CustomToaster,
  },
  computed: {
    ...mapGetters(["getUserShopId"]),
  },
  methods: {
    goBack(){
      let pathvalue;
      if(this.$route.query.CLOUDSHOP){
        pathvalue = `/add-product?shopid=${this.$route.query.shopid}&CLOUDSHOP=YES`
      }else{
        pathvalue = `/add-product?shopid=${this.$route.query.shopid}`
      }
      this.$router.push(pathvalue)
    },
    searchQuery(event) {
      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        this.searchInput = event.target.value;
        this.productDetails = [];
        this.searchResult(this.searchInput);
      } else {
        this.searchInput = event.target.value;
        this.productDetails = [];
        this.searchResult(this.searchInput);
      }
    },
    searchResult(searchInput) {
      ApiCaller(
        constant.CATALOGUE_URL,
        "get-seller-search-product-to-add",
        "post",
        {
          searchTerm: searchInput,
        }
      )
        .then((data) => {
          if (
            data.data &&
            data.data.productDTOs &&
            data.data.productDTOs.length > 0
          ) {
            this.productDetails = data.data.productDTOs;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addScannedProduct(product, index) {
      this.loading = true;
      product.itemDTOList[0].sellerShopId = this.getUserShopId;
      ApiCaller(constant.CATALOGUE_URL, "upload-product", "post", product)
        .then((data) => {
          this.loading = false;
          this.toasterData = {
            msg: "Added to Shop Successfully",
            color: "#138808",
            iconName: "check",
          };
          this.productDetails.splice(index, 1);
          this.isValidDetail = true;
          // this.searchInput=''
        })
        .catch((err) => {
          this.loading = false;
          if (
            err.response.data.errorCodes[0] == "ITEM_ALREADY_EXISTS_IN_SHOP"
          ) {
            this.toasterData = {
              msg: "Item already exits in shop",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          } else {
            this.toasterData = {
              msg: "Something went wrong",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          }
        });
    },
  },
};
</script>
